import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../partials/Footer";
import Header from "../partials/Header";
import MobileFooter from "../partials/MobileFooter";
import MobileHeader from "../partials/MobileHeader";
import MobileSideFilter from "../partials/MobileSideFilter";
import SideFilter from "../partials/SideFilter";
import { companyData } from "../data/Company";
import { mentorData } from "../data/Mentor";

function Dashboard() {
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [mentors, setMentors] = useState([]);

  const [searchTerm, setSearchTerm] = useState(" ");
  const history = useHistory();

  useEffect(() => {
    // setAllData(companyData);
    // setMentorData(mentorData);
  }, []);

  useEffect(() => {
    setData(
      companyData?.filter((data) =>
        data.company_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setMentors(
      mentorData?.filter((data) =>
        data.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm]);

  const redirect = (id) => {
    history.push(`/detail/${id}`);
  };

  const redirectMentor = (id) => {
    history.push(`/mentor/${id}`);
  };

  // console.log(data);

  return (
    <div>
      <Header />
      <div className="body__container">
        {/* <div className="bread__crump">
          <i className="fa fa-home" aria-hidden="true" />
        </div> */}
        <div style={{ margin: "20px 0px" }} className="banner__div">
          <img src="/assets/images/homebanner1.png" alt="banner" width="65%" />
        </div>
        <div className="">
          <div className="side__sub">
            <MobileSideFilter setSearchTerm={setSearchTerm} />
          </div>
          {/* <div className="header__text">The Standard Loren Ipsum</div> */}
          <div className="body__content">
            <div className="side__main">
              <SideFilter setSearchTerm={setSearchTerm} />
            </div>
            <div className="display__container col-sm-10">
              <h3>StartUps</h3>
              <div className="row" style={{ width: "100%" }}>
                {data?.map((data, i) => {
                  return (
                    <div
                      key={i}
                      className="display__cards"
                      onClick={() => redirect(data?.id)}
                    >
                      <div className="logo__div">
                        <img className="logo__disp" src={data.company_logo} />
                      </div>
                      <div>{data.company_name}</div>
                      {/* <div>{data.}</div> */}
                      <div className="card__loc">Chennai</div>
                    </div>
                  );
                })}
              </div>
              <h3>Mentors</h3>
              <div className="row" style={{ width: "100%" }}>
                {mentors?.map((data, i) => {
                  return (
                    <div
                      key={i}
                      className="display__cards"
                      onClick={() => redirectMentor(data?.id)}
                    >
                      <div className="logo__div">
                        <img className="logo__disp" src={data.profile} />
                      </div>
                      <div>{data.name}</div>
                      {/* <div>{data.}</div> */}
                      <div className="card__loc">{data.desg}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main__footer">
        <Footer />
      </div>
      <div className="sub__footer">
        <MobileFooter />
      </div>
    </div>
  );
}

export default Dashboard;
